export default "__VITE_ASSET__BMYukSxh__"